import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TripHeader = ({ trip, onSave, hasUnsavedChanges }) => {
  const navigate = useNavigate();
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const handleGeneratePDF = async () => {
    setIsGeneratingPDF(true);
    // Simulate PDF generation delay
    setTimeout(() => {
      setIsGeneratingPDF(false);
      navigate('/pdf-generation-download', { state: { trip } });
    }, 1500);
  };

  const handleBackToDashboard = () => {
    if (hasUnsavedChanges) {
      if (window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
        navigate('/user-dashboard');
      }
    } else {
      navigate('/user-dashboard');
    }
  };

  return (
    <div className="bg-card border-b border-border p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={handleBackToDashboard}
            className="flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-organic"
          >
            <Icon name="ArrowLeft" size={20} />
            <span className="font-body">Back to Dashboard</span>
          </button>
          
          <div className="flex items-center space-x-3">
            {hasUnsavedChanges && (
              <div className="flex items-center space-x-2 text-warning">
                <Icon name="AlertCircle" size={16} />
                <span className="text-sm font-body">Unsaved changes</span>
              </div>
            )}
            
            <Button
              variant="outline"
              onClick={onSave}
              iconName="Save"
              iconPosition="left"
              disabled={!hasUnsavedChanges}
            >
              Save Changes
            </Button>
            
            <Button
              variant="default"
              onClick={handleGeneratePDF}
              loading={isGeneratingPDF}
              iconName="Download"
              iconPosition="left"
            >
              Generate PDF
            </Button>
          </div>
        </div>
        
        <div className="flex items-start justify-between">
          <div>
            <h1 className="font-heading font-heading-bold text-3xl text-foreground mb-2">
              {trip?.destination}
            </h1>
            <div className="flex items-center space-x-6 text-muted-foreground">
              <div className="flex items-center space-x-2">
                <Icon name="Calendar" size={16} />
                <span className="font-body text-sm">
                  {new Date(trip.startDate)?.toLocaleDateString('en-US', { 
                    month: 'long', 
                    day: 'numeric', 
                    year: 'numeric' 
                  })} - {new Date(trip.endDate)?.toLocaleDateString('en-US', { 
                    month: 'long', 
                    day: 'numeric', 
                    year: 'numeric' 
                  })}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} />
                <span className="font-body text-sm">{trip?.participants} participants</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} />
                <span className="font-body text-sm">{trip?.state}</span>
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="px-3 py-1 bg-success/10 text-success rounded-organic-sm">
              <span className="font-body font-body-medium text-sm">Confirmed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripHeader;